import React from 'react';
import { createRoot } from 'react-dom/client';
import { AlertCircle } from 'lucide-react';
import './AlertPopup.css';

export const showAlert = (title, message) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = createRoot(container);

  const handleClose = () => {
    // animate out if we want to, but simplest is unmount
    root.unmount();
    container.remove();
  };

  root.render(
    <div className="alert-popup-overlay">
      <div className="alert-popup-content slide-up">
        <div className="alert-popup-header">
          <AlertCircle size={24} color="var(--primary-color)" />
          <h3>{title}</h3>
        </div>
        <div className="alert-popup-body">
          <p>{message}</p>
        </div>
        <div className="alert-popup-footer">
          <button className="btn-primary" onClick={handleClose} style={{ padding: '0.5rem 2rem' }}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export const showConfirm = (title, message) => {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const root = createRoot(container);

    const cleanup = () => {
      root.unmount();
      container.remove();
    };

    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };

    const handleCancel = () => {
      cleanup();
      resolve(false);
    };

    root.render(
      <div className="alert-popup-overlay">
        <div className="alert-popup-content slide-up">
          <div className="alert-popup-header">
            <AlertCircle size={24} color="var(--warning-color)" />
            <h3>{title}</h3>
          </div>
          <div className="alert-popup-body">
            <p>{message}</p>
          </div>
          <div className="alert-popup-footer" style={{ gap: '1rem' }}>
            <button className="btn-outline" onClick={handleCancel} style={{ padding: '0.5rem 1.5rem', color: 'var(--text-main)', borderColor: 'var(--border-color)' }}>
              Cancelar
            </button>
            <button className="btn-primary" onClick={handleConfirm} style={{ padding: '0.5rem 1.5rem', backgroundColor: 'var(--danger-color)', borderColor: 'var(--danger-color)' }}>
              Confirmar
            </button>
          </div>
        </div>
      </div>
    );
  });
};
